import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider, Grid, Stack, Tooltip, Typography } from "@mui/material";
import TextInput from "src/qubCommon/Inputs/TextInput";
import Dropdown from "src/qubCommon/Inputs/Dropdown";
import { FormProvider } from "react-hook-form";
import FormCheckbox from "src/qubCommon/Inputs/Checkbox";
import { useLookup } from "src/context/lookupContext";
import { v4 as uuidv4 } from "uuid";
import { deleteFile, getFiles } from "apis/controllers/files";
import { Add, AttachFile, Delete } from "@mui/icons-material";
import AlertBanner from "../AlertBanner";
import { enqueueSnackbar } from "notistack";
import AmkaInput from "qubCommon/Inputs/AmkaInput";
import DynamicDialog from "qubCommon/Dialogs/DynamicDialog";

export default function FatherFormDialog(props) {
  const {
    open,
    handleClose,
    fatherForm,
    handleAddRow,
    handleEditRow,
    canEdit,
    canPartiallyEdit,
    applicantAmka,
  } = props;
  const { lookups } = useLookup();
  const [files, setFiles] = React.useState([]);
  const [dialog, setDialog] = React.useState({
    title: "Σφάλμα",
    message: "Σφάλμα",
  });
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const editId = fatherForm?.getValues("id");

  const findLookupObject = (lookupTable, value, fieldName) => {
    const selectedObject = lookupTable?.find((record) => record?.id === value);
    fatherForm.setValue(fieldName, selectedObject.name);
  };

  return (
    <FormProvider {...fatherForm}>
      <DynamicDialog
        open={dialogOpen}
        meta={{
          title: dialog?.title,
          description: dialog?.message,
          action: "OK",
        }}
        onAccept={dialog.onAccept}
        hideSecondaryButton
        type="error"
      />
      <Dialog
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontSize: "18px" }}
          id="customized-dialog-title"
        >
          Στοιχεία Γονέα / Προσώπου με Σχέση Ασφάλισης ή Επιμέλειας
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Divider />
        <DialogContent
          sx={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <AlertBanner
            info={{
              message: ` <div>Η ${editId ? "Ενημέρωση" : "Προσθήκη"
                } θα πραγματοποιηθεί μετά την αποθήκευση της αίτησης.</div> `,
              cssClass: "info",
            }}
          />
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {/* 1. amka and 2. oganr in the same row */}
            <Grid item xs={12} md={6}>
              <AmkaInput
                name="amka"
                label="ΑΜΚΑ"
                disabled={!canEdit && !canPartiallyEdit}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput
                name="ama"
                label="Α.Μ.ΟΓΑ/ΕΦΚΑ"
                disabled={!canEdit && !canPartiallyEdit}
              />
            </Grid>
            {/* 3. firstName and 4. lastName in the same row */}
            <Grid item xs={12} md={6}>
              <TextInput
                name="firstName"
                label="Όνομα"
                disabled={!canEdit && !canPartiallyEdit}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput
                name="lastName"
                label="Επώνυμο"
                disabled={!canEdit && !canPartiallyEdit}
              />
            </Grid>
            {/* 5. relation full row */}
            <Grid item xs={12} md={12}>
              <Dropdown
                name="relationship.id"
                options={lookups?.husbandRelationships || []}
                label="Σχέση με Δικαιούχο"
                labelName="name"
                valueName="id"
                changeFn={(e) => {
                  findLookupObject(
                    lookups?.husbandRelationships,
                    e.target.value,
                    "relationship.name"
                  );
                }}
                disabled={!canEdit && !canPartiallyEdit}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ width: "90%", mx: "auto" }}>
          <Button
            variant="contained"
            color="secondary"
            sx={{ color: "#fefefe", marginRight: "auto" }}
            autoFocus
            onClick={handleClose}
          >
            Πίσω
          </Button>
          <Button
            sx={{}}
            onClick={fatherForm.handleSubmit((data) => {
              if (applicantAmka === data?.amka) {
                setDialog({
                  title: "Σφάλμα",
                  message:
                    "Βρίσκεστε στό τμήμα προσθήκης έτερων γονέων.\nΤο ΑΜΚΑ που εισάγατε έχει δηλωθεί στον δικαιούχο\nΠαρακαλώ ελέγξτε και προσπαθήστε ξανά.",
                  onAccept: () => setDialogOpen(false),
                });
                setDialogOpen(true);
                return;
              }
              const father = fatherForm.getValues();
              if (!editId) {
                fatherForm.setValue("id", uuidv4());
                fatherForm.setValue("isNew", true);
              }
              editId
                ? handleEditRow(fatherForm.getValues())
                : handleAddRow(fatherForm.getValues());
            })}
            variant="contained"
            autoFocus
          >
            {editId ? "Ενημέρωση" : "Προσθήκη"}
          </Button>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
}
